import SelectInput, { INPUT_SIZES, THEME_TYPES } from './SelectInput';

export default SelectInput;

export { THEME_TYPES, INPUT_SIZES };
